<div [style.position]="'relative'" [style.cursor]="showingPassword ? 'pointer' : 'not-allowed'">
  <input
    class="password-input"
    [type]="showingPassword ? 'text' : 'password'"
    inputmode="text"
    autocomplete="off"
    [attr.id]="controlId"
    [value]="value"
    [disabled]="disabled"
    [ngClass]="{
      'error-border': error
    }"
    (input)="handleInput($event)" />

  <button
    class="eye"
    (click)="toggleShowHide()"
    [disabled]="disabled"
    type="button"
    [ngClass]="{
      opened: showingPassword,
      closed: !showingPassword,
      error: error,
      disabled: disabled
    }"></button>
</div>
